import React from 'react';
import {
	Card,
	CardContent,
	CardFooter,
	CardHeader,
} from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface BlogSidebarCardProps {
	icon?: React.ReactNode;
	title: string;
	headerClassName?: string;
	contentClassName?: string;
	footerClassName?: string;
	children: React.ReactNode;
	footer?: React.ReactNode;
}

export const BlogSidebarCard = ({
	icon,
	title,
	headerClassName,
	contentClassName,
	footerClassName,
	children,
	footer,
}: BlogSidebarCardProps) => {
	return (
		<Card className="overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-sm">
			<CardHeader
				className={cn(
					'flex-row items-center justify-start gap-1.5 border-b border-neutral-200 bg-neutral-50 px-4 py-2.5',
					headerClassName,
				)}>
				{icon && (
					<span className="flex-shrink-0 text-primary">{icon}</span>
				)}
				<h3 className="text-sm font-semibold leading-tight text-neutral-900">
					{title}
				</h3>
			</CardHeader>
			<CardContent className={cn('p-4', contentClassName)}>
				{children}
			</CardContent>
			{footer && (
				<CardFooter
					className={cn(
						'border-t border-neutral-100 bg-neutral-50 px-6 py-3',
						footerClassName,
					)}>
					{footer}
				</CardFooter>
			)}
		</Card>
	);
};
